import { GameUI } from "game/gameUI/GameUI";
import { translate } from "game/translate"
import { Popups } from "ui/types/popups";

export const AdblockPopup = () => {
    const handleCloseBtnClick = () => {
        GameUI.closePopup(Popups.ADBLOCKER_POPUP);
    }

    const handleAdblockerBtnClick = () => {
        GameUI.closePopup(Popups.ADBLOCKER_POPUP, true);
    }

    return (
        <div id="adblocker" role="tooltip" className="modals_area active">
            <div className="wrapper">
                <button id="closing-ignore-el" type="button" className="close_btn close" onClick={handleCloseBtnClick}></button>
                <div className="text_content">
                    <span className="modals_area-title">{translate("adblocker_title")}</span>
                    <img loading="lazy" className="modals_area_img" src="/assets/adblocker/adblocker.webp" alt={translate("adblocker_title")} />
                    <p className="modals_area-text">{translate("adblocker_text")}</p>
                    <button id="closing-ignore-el" type="button" className="modals_area-btn" onClick={handleAdblockerBtnClick}>{translate("adblocker_btn")}</button>
                </div>
            </div>
        </div>
    )
}